export default __webpack_public_path__ + "static/media/home.204603c7.png";